// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  background-color: #f0f2f5 !important;\n}\n.dynamic-delete-button {\n  font-size: 2em;\n  margin-left: 0.5em;\n  color: red !important;\n}\n.compact-form-item {\n  margin-bottom: 0px !important;\n}\n.display-linebreak {\n  white-space: pre-line;\n}\n.ant-layout-sider {\n  overflow: visible !important;\n}\n.msg-list-dialog .ant-modal-confirm-content {\n  margin: 0 !important;\n}\n.user-disabled {\n  background-color: #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
